import { forwardRef } from "react";
import { Button, useTab } from "@chakra-ui/react";
import { secondary } from "theme/button";

const SecondaryTabButton = forwardRef<HTMLElement, any>((props, ref) => {
  const tabProps = useTab({ ...props, ref });
  const isSelected = !!tabProps["aria-selected"];

  return (
    <Button
      variant={isSelected ? "solid" : "outline"}
      sx={{
        ...secondary,
        _hover: isSelected
          ? { backgroundColor: "brand.500", color: "white" }
          : { backgroundColor: "brand.100", color: "brand.600" },
        _active: { backgroundColor: "brand.500", color: "white" },
      }}
      {...tabProps}
    />
  );
});
SecondaryTabButton.displayName = "SecondaryTabButton";

export default SecondaryTabButton;
